import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import Carousel from '../../../../commonComponents/carousel/Carousel';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import shippingProviderProp from '../../../shop/propTypes/shippingProviderProp';
import DisplayShippingItem from './DisplayShippingItem';
import OutlinePlusIcon from '../../../../commonComponents/icons/OutlinePlusIcon';

function DisplayShippingContainer({
  t,
  shipping,
  isProvider,
  currencies,
  onShippingChange,
  onAddShipping,
  shippingSelected,
  isShippingAddress,
  shippingCountry,
  includesBilling,
  user,
  onAddressOpen,
}) {
  const initialShippingAddress = () => {
    const shippingList = shipping;
    // Select the first shipping address, if is company it chooses the first, if its individual it chooses the first valid
    if (
      shippingCountry &&
      (!user?.personalInfo?.businessType ||
        user?.personalInfo?.businessType === 'individual')
    ) {
      return shippingList.find(s => s.countryCode === shippingCountry);
    }
    return shippingList[0];
  };
  /** INITIAL STATE */
  const initialSelectedShipping = !isProvider
    ? shipping
    : shipping.filter(
        s =>
          (s?.userPrice?.price >= 0 && s?.userPrice?.code) ||
          (s?.userClickAndCollectPrice?.price >= 0 &&
            s?.userClickAndCollectPrice?.code),
      );

  const [selectedShipping, setSelectedShipping] = useState(
    shippingSelected
      ? initialSelectedShipping.find(s => s._id === shippingSelected)
      : initialShippingAddress(),
  );

  // Handles changes in radio button
  const handleSelectShipping = useCallback(s => {
    setSelectedShipping(s);
  }, []);

  // Updating the father component with the selected shipping
  useEffect(() => {
    onShippingChange(selectedShipping);
  }, [selectedShipping]);

  useEffect(() => {
    setSelectedShipping(
      shippingSelected
        ? initialSelectedShipping.find(s => s._id === shippingSelected)
        : initialShippingAddress(),
    );
  }, [shipping]);

  /** Render the component */
  return (
    <>
      {initialSelectedShipping.length ? (
        <Carousel>
          {[...initialSelectedShipping, null].map((s, index) => {
            return s ? (
              <DisplayShippingItem
                key={s._id || s.id}
                shipping={s}
                index={index}
                selectedShipping={selectedShipping}
                onSelectShipping={handleSelectShipping}
                isProvider={isProvider}
                currencies={currencies}
                shippingCountry={shippingCountry}
                user={user}
                isShippingAddress={isProvider ? false : isShippingAddress}
                includesBilling={includesBilling}
                onAddressOpen={onAddressOpen}
              />
            ) : (
              <>
                {!isProvider ? (
                  <button
                    key={`s_${index}`}
                    type="button"
                    onClick={() => onAddressOpen('shipping', null)}
                    className="shipping-item add-shipping"
                  >
                    <OutlinePlusIcon color="#C5C5C5" />
                  </button>
                ) : null}
              </>
            );
          })}
        </Carousel>
      ) : (
        !isProvider && (
          <>
            {onAddShipping ? (
              <div className="col-lg-12 button-add-newProduct">
                <button
                  type="button"
                  onClick={onAddShipping}
                  className="btn btn-metal m-btn m-btn--icon
                                     m-btn--icon-only m-btn--custom m-btn--outline-2x
                                     m-btn--pill m-btn--air form"
                >
                  <i className="la la-plus" />
                  <span>{t('shop.cart.add_new_address')}</span>
                </button>
              </div>
            ) : (
              <span className="no-customer-shipping-error">
                {t('error_shipping_address')}
                <button
                  className="edit-address"
                  type="button"
                  onClick={() => onAddressOpen('shipping', null)}
                >
                  <i className="fa fa-user-edit" />
                </button>
              </span>
            )}
          </>
        )
      )}
    </>
  );
}

DisplayShippingContainer.propTypes = {
  t: PropTypes.func.isRequired,
  shipping: PropTypes.arrayOf(PropTypes.shape(shippingProviderProp.propType))
    .isRequired,
  shippingSelected: PropTypes.string,
  isProvider: PropTypes.bool,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)),
  user: PropTypes.shape(UserProp.propType),
  onShippingChange: PropTypes.func.isRequired,
  onAddShipping: PropTypes.func,
  isShippingAddress: PropTypes.bool,
  shippingCountry: PropTypes.string,
  includesBilling: PropTypes.bool,
  onAddressOpen: PropTypes.func.isRequired,
};
DisplayShippingContainer.defaultProps = {
  isProvider: false,
  currencies: [],
  shippingSelected: null,
  isShippingAddress: false,
  shippingCountry: null,
  includesBilling: false,
  onAddShipping: null,
  user: null,
};

export default translate(DisplayShippingContainer);
